import { render } from "./VueSwitch.vue?vue&type=template&id=3d3d1e96&scoped=true"
import script from "./VueSwitch.vue?vue&type=script&lang=js"
export * from "./VueSwitch.vue?vue&type=script&lang=js"

import "./VueSwitch.vue?vue&type=style&index=0&id=3d3d1e96&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3d1e96"]])

export default __exports__